export const SINGLE_POINT_LAYER_ID = 'single-point-layer' as const;

export const SELECTED_POINT_LAYER_ID = 'selected-point-layer' as const;
export const SELECTED_POINT_OVERLAY_LAYER_ID =
  'selected-point-overlay-layer' as const;

export const CLUSTER_CIRCLE_LAYER_ID = 'clusters' as const;
export const CLUSTER_COUNT_LAYER_ID = 'cluster-count' as const;

export const BLOCKS_BOUNDARY_SOURCE_ID = 'blocks-boundary';
export const POINTS_SOURCE_ID = 'points';
